import Bullet from 'components/ui/Icon/Icons/Bullet';
import { useTranslation } from 'hooks/useTranslation';
import Link from 'components/ui/Link';
import { useRouter } from 'next/router';
import { convertStringIntoAnchorLink } from 'utils/string';
import { BLOCKS } from '@contentful/rich-text-types';
import clsx from 'clsx';
import styles from './TableOfContents.module.scss';
import type { Text, Block } from '@contentful/rich-text-types';

// eslint-disable-next-line
// @ts-ignore
export const getTitles = (entry): string[] => {
  const items = entry?.content?.items || entry?.items;

  // eslint-disable-next-line
  // @ts-ignore
  return items?.reduce((titles: string[], val) => {
    if (val?.__typename === 'ContentTypeRichText') {
      val?.textContent?.json.content.map((innerContent: Block) => {
        if (innerContent.nodeType === BLOCKS.HEADING_2) {
          titles.push((innerContent.content[0] as Text).value);
        }
      });
    }

    return titles;
  }, []);
};

type Props = {
  titles: string[];
  wrapperClasses?: string;
};

const TableOfContents = ({ titles, wrapperClasses }: Props): JSX.Element => {
  const { t } = useTranslation();
  const { asPath } = useRouter();

  const anchorLink = asPath.split('#')?.[1];
  const selectedIndex = titles.findIndex(
    (title) => convertStringIntoAnchorLink(title) === anchorLink,
  );

  return (
    <div className={clsx(styles.wrapper, wrapperClasses)}>
      <div className={styles.title}>{t('treatmentPage.tableOfContents')}</div>
      <ul className={styles.list}>
        {titles?.map((title, i) => {
          const anchorLink = convertStringIntoAnchorLink(title);
          const href = `#${anchorLink}`;
          return (
            <li key={i}>
              <div className={styles.iconWrapper}>
                {selectedIndex === i ? (
                  <Bullet innerColor="#155263" outerColor="#A5CAD5" />
                ) : (
                  <div className={styles.icon} />
                )}
              </div>
              <Link href={href} className={styles.item} legacyBehavior={false}>
                {title}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default TableOfContents;
